import { ChangeDetectionStrategy, Component, inject, Injector, OnInit, ViewChild } from '@angular/core';
import { App } from '@df/core/app';
import { AfterContentInitDirectiveService } from '@df/ui/common/after-content-init.directive';
import { UiComponent } from '@df/ui/ui.component';
import { EXIT_COMPONENT_EDIT_EVENT } from '@icms/core/integration/icms-core-integration-interfaces';
import { BehaviorSubject } from 'rxjs';
import { PageHeaderComponent } from './page/header/page-header.component';
import { NPageOffCanvas } from './page/off-canvas/page-off-canvas.component';
export const PAGE_HEADER_WRAPPER_ELEMENT = 'page-header-wrapper';

@Component({
    selector: 'app-root',
    templateUrl: './app-root.html',
    styleUrls: ['./app-root.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppRootComponent extends UiComponent implements OnInit {
    /**
     * Header element id used withe element height
     */
    readonly headerElementId = PAGE_HEADER_WRAPPER_ELEMENT;

    /**
     * If off canvas is visible
     */
    readonly offCanvasState = new BehaviorSubject<NPageOffCanvas.EOpenState>(NPageOffCanvas.EOpenState.closed);
    protected isAfterContentInit = false;

    protected hasHeader = false;
    private _pageHeader?: PageHeaderComponent;

    private app = inject(App);
    private afterContentInitDirectiveService = inject(AfterContentInitDirectiveService);

    get hasPageContentClass() {
        return this.isAfterContentInit;
    }

    get pageHeader(): PageHeaderComponent | undefined {
        return this._pageHeader;
    }

    @ViewChild('pageHeader')
    set pageHeader(value: PageHeaderComponent | undefined) {
        if (value) {
            const subs = value.hasContent$.subscribe(hasContent => {
                if (!this.hasHeader && hasContent) {
                    this.hasHeader = hasContent;
                    this.detectChanges();

                    this.timeoutService.setTimeout(() => {
                        subs.unsubscribe();
                        this.afterContentInitDirectiveService.unlock(this);
                    });
                }
            });

            const sub2 = this.afterContentInitDirectiveService.ready.subscribe(ready => {
                if (ready) {
                    this.isAfterContentInit = true;
                    this.detectChanges();
                }
                this.timeoutService.setTimeout(() => {
                    sub2.unsubscribe();
                });
            });
        }

        this._pageHeader = value;
    }

    override ngOnInit() {
        this.afterContentInitDirectiveService.lock(this);
        this.offCanvasState.subscribe(state => {
            this.app.events.broadcast(EXIT_COMPONENT_EDIT_EVENT);
        });
        super.ngOnInit();
    }
}
